/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { d as debounce_1 } from '../_chunks/dep-01ce608f.js';
import { useCallback, useEffect } from 'react';
import { usePersistFn } from '../_util/usePersistFn.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-77a54538.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';

var useDebounce = function useDebounce(func, delay, options) {
  var callback = usePersistFn(func);
  var debounced = useCallback(debounce_1(callback, delay, options), [callback, delay, options]);
  useEffect(function () {
    return debounced.cancel;
  }, [debounced]);
  return debounced;
};

export { useDebounce as default };
//# sourceMappingURL=useDebounce.js.map
